import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  reduxForm,
} from 'redux-form';
import {
  Col,
  Container,
  Row,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import DataTable from '../../../shared/components/DataTable';

import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import {
  filterSurvey,
  removeHomework,
} from '../../../redux/actions/materiaPeriodoActions';
import Confirm from '../../../shared/components/Confirm';
import {
  dateFormat,
} from '../../../helpers/dateFormat';
import { createErrorMessage, createSuccessMessage } from '../../../helpers/notification';
import SurveyForm from './SurveyForm/index';

class SurveyContainer extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    materiaPeriodoId: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 10 },
      showForm: false,
      recordId: 0,
    };

    this.handleSubmit.bind(this);

    this.checkBoxLabelStyle = {
      marginTop: '0px',
      display: 'flex',
      justifyContent: 'center',
    };

    this.columns = () => [
      { key: 'id', name: '#', width: '85px' },
      {
        key: 'spreadsheetId',
        name: 'Spreadsheet Id',
        className: 'text-center',
      },
      {
        key: 'sheetName', name: 'Hoja', width: '300px', search: true,
      },
      {
        key: 'emailColumn',
        name: 'Columna Email',
        width: '120px',
        className: 'text-center',
      },
      {
        key: 'createdAt',
        name: 'Fecha Alta',
        search: false,
        className: 'text-center',
        width: '100px',
        format: row => dateFormat(row.createdAt),
      },
      {
        key: 'activa',
        name: 'Activa',
        search: false,
        className: 'text-center',
        width: '90px',
        format: ({ activa }) => (activa ? 'Si' : 'No'),
      },
      {
        key: 'actions',
        name: 'Accion',
        width: '85px',
        className: 'text-center',
      },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar" />,
        callback: (record) => {
          this.edit(record);
        },
      },
      {
        key: 'delete',
        visible: false,
        icon: row => (
          <>
            <span id={`UncontrolledPopover${row.id}`} className="fa fa-trash" title="Borrar" />
            <UncontrolledPopover
              trigger="legacy"
              placement="left"
              target={`UncontrolledPopover${row.id}`}
              className="info"
              disabled={!row.cantidadInscriptos}
            >
              <PopoverHeader>No se puede borrar la encuesta</PopoverHeader>
              <PopoverBody>Hay alumnos que entregaron la encuesta.</PopoverBody>
            </UncontrolledPopover>
          </>
        ),
        callback: (record) => {
          if (!record.cantidadInscriptos) {
            this.handleDeleteAction(record);
          }
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateTable(page, pageSize);
  }

  updateTable = (page, pageSize, filters) => {
    const {
      materiaPeriodoId,
    } = this.props;

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });

    filterSurvey({
      materiaPeriodoId,
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ items, totalItemsCount }) => {
        this.setState({
          loading: false,
          items,
          totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de encuentas por materia');
      },
    });
  }

  handleDeleteAction = (record) => {
    const name = `${record.descripcion}`;
    Confirm({
      title: 'Borrar encuesta',
      question: `Estás seguro que deseas eliminar esta encuesta "${name}"?`,
      yesLabel: 'Si, Borrar',
      noLabel: 'No, Volver',
      onConfirm: () => {
        removeHomework(record.id, {
          onSuccess: () => {
            createSuccessMessage('Encuesta borrado exitosamente');
            const { page, pageSize } = this.state;
            this.updateTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La encuesta no existe');
            } else {
              createErrorMessage('Error al intentar borrar encuesta');
            }
          },
        });
      },
    });
  };

  handleHideForm = () => {
    this.setState({
      showForm: false,
      recordId: 0,
    });

    this.onDataTableClearFilters();
  };

  edit = (record) => {
    this.setState({
      showForm: true,
      recordId: record.id,
    });
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize, filters } = this.state;
    const { autoHideSearch } = filters;
    this.updateTable(1, pageSize, { autoHideSearch });
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  handleSubmit = () => {
    const { handleSubmit } = this.props;

    handleSubmit({});
  };

  render() {
    const {
      loading,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    const {
      materiaPeriodoId,
    } = this.props;

    const {
      showForm,
      recordId,
    } = this.state;

    if (showForm) {
      return (
        <div className="table-wrapper">
          <table className="table table-striped check-in">
            <thead>
              <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                <th>
                  <div className="invoice-detail">
                    <Row>
                      <Col md={12}>
                        <SurveyForm
                          id={recordId}
                          materiaPeriodoId={materiaPeriodoId}
                          onHideForm={this.handleHideForm}
                        />
                      </Col>
                    </Row>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      );
    }

    const {
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <div className="table-wrapper">
        <table className="table table-striped check-in">
          <thead>
            <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
              <th>
                <div className="invoice-detail">
                  <Row>
                    <Col md={12}>
                      <Container>
                        <Row>
                          <Col md={3} sm={5}>
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary"
                              onClick={() => this.edit({ id: 0 })}
                            >
                              <i className="fa fa-plus" /> Agregar Nueva Encuesta
                            </button>
                          </Col>
                        </Row>
                        <Row>
                          <DataTable
                            title="Listado de todas las encuestas"
                            columns={this.columns()}
                            items={items}
                            onChangePage={this.onChangePage}
                            totalItemsCount={totalItemsCount}
                            onSubmit={this.onDataTableSubmit}
                            onClearFilters={this.onDataTableClearFilters}
                            getGridActions={key => this.getGridActions(key)}
                            onAutoSave={this.autoguardarNota}
                            itemsToShow={items.length}
                            page={page}
                            pageSize={pageSize}
                            autoHideSearch={filters.autoHideSearch}
                            initialValues={filters}
                            enableReinitialize
                          />
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
    );
  }
}

const ReduxSurveyContainer = reduxForm({
  form: 'SurveyContainer',
  // validate,
  enableReinitialize: true,
})(SurveyContainer);

export default setPropsAsInitialValues(ReduxSurveyContainer);
